import React from "react";
import { Star } from "lucide-react";
import { ArrowRight } from "lucide-react";

const TestimonialsGrid = () => {
  return (
    <section className="py-20 md:py-28 bg-white">
      <div className="max-w-[1300px] mx-auto px-6 md:px-12 lg:px-24">
        {/* Bento Grid: 3 columns, Card 1 spans 2 rows */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 auto-rows-auto">

          {/* Card 1 — Tall testimonial (spans 2 rows) */}
          <div className="md:row-span-2 bg-[#F5F5F5] rounded-2xl border border-[#A7A2B4] p-7 flex flex-col justify-between min-h-[260px]">
            <div>
              {/* Green stars */}
              <div className="flex items-center gap-0.5 mb-5">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" />
                ))}
              </div>
              {/* Quote */}
              <blockquote
                className="text-[19px] md:text-[21px] text-[#1a1a2e] leading-snug"
                style={{ fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 }}
              >
                "Our teams went from experimenting with ChatGPT to automating parts of their day to day workflows."
              </blockquote>
            </div>
            {/* Logo only - left aligned */}
            <div className="mt-8">
              <div className="h-14">
                <img 
                  src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/hi0apl0p_image.png" 
                  alt="Konverge AI" 
                  className="h-full w-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Card 2 — Stat card (2x) with Konverge AI */}
          <div className="bg-[#F5F5F5] rounded-2xl border border-[#A7A2B4] p-7 flex flex-col justify-between min-h-[260px]">
            <div>
              <p
                className="text-[56px] font-bold text-[#1a1a2e] leading-none"
                style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
              >
                2x
              </p>
              <p className="text-[16px] text-gray-500 mt-2">Faster talent deployment</p>
            </div>
            {/* Konverge AI logo */}
            <div className="mt-6">
              <div className="h-12">
                <img 
                  src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/hi0apl0p_image.png" 
                  alt="Konverge AI" 
                  className="h-full w-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Card 3 — Testimonial with mycaptain */}
          <div className="bg-[#F5F5F5] rounded-2xl border border-[#A7A2B4] p-7 flex flex-col justify-between min-h-[260px]">
            <div>
              {/* Purple stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" />
                ))}
              </div>
              {/* Quote */}
              <blockquote
                className="text-[20px] md:text-[22px] text-[#1a1a2e] leading-snug"
                style={{ fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 }}
              >
                Elevante helps 1000+ of our learners every month, to truly learn and practice AI
              </blockquote>
            </div>
            {/* Author - without photo */}
            <div className="flex items-center justify-between mt-6">
              <div>
                <p className="text-[13px] font-bold text-[#1a1a2e]">Mohammed Zeeshan</p>
                <p className="text-[12px] text-gray-500">CEO</p>
              </div>
              <div className="h-10">
                <img 
                  src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/jr09aty2_image.png?v=2" 
                  alt="mycabal" 
                  className="h-full w-auto object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

          {/* Card 4 — Professor testimonial */}
          <div className="bg-[#F5F5F5] rounded-2xl border border-[#A7A2B4] p-7 flex flex-col justify-between min-h-[260px]">
            <div>
              {/* Purple stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" />
                ))}
              </div>
              {/* Quote */}
              <blockquote
                className="text-[19px] md:text-[21px] text-[#1a1a2e] leading-snug"
                style={{ fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 }}
              >
                The platform makes it easy and intuitive to teach AI across degrees.
              </blockquote>
            </div>
            {/* Author - without photo */}
            <div className="flex items-center justify-between mt-6">
              <div>
                <p className="text-[13px] font-bold text-[#1a1a2e]">Ketan Paithankar</p>
                <p className="text-[12px] text-gray-500">Professor of Practice in AI, IIM Nagpur, MICA</p>
              </div>
              <div className="flex items-center gap-1">
                <div className="h-12">
                  <img 
                    src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/yyag5gi7_image.png" 
                    alt="IIM Kozhikode" 
                    className="h-full w-auto object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Card 5 — Azim Premji University card with 3D FLIP animation */}
          <div className="hotjar-flip-card rounded-2xl min-h-[260px] cursor-pointer" style={{ perspective: "1000px" }}>
            <div className="hotjar-flip-inner relative w-full h-full rounded-2xl" style={{ transition: "transform 0.6s ease", transformStyle: "preserve-3d" }}>
              {/* Front face — Testimonial */}
              <div
                className="absolute inset-0 flex flex-col justify-between p-6 bg-[#F5F5F5] rounded-2xl border border-[#A7A2B4]"
                style={{ backfaceVisibility: "hidden" }}
              >
                <div>
                  {/* Stars */}
                  <div className="flex items-center gap-0.5 mb-3">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-[#FBBF24] text-[#FBBF24]" />
                    ))}
                  </div>
                  {/* Quote */}
                  <blockquote
                    className="text-[16px] md:text-[17px] text-[#1a1a2e] leading-tight"
                    style={{ fontFamily: "'Playfair Display', Georgia, serif", fontWeight: 700 }}
                  >
                    The session was very hands-on and easy to follow, especially with tools like Claude, ChatGPT, Gamma, and Napkin AI being used for real research tasks. Seeing how each tool fits into different aspects and stages of research made it very useful.
                  </blockquote>
                </div>
                {/* Attribution */}
                <div className="mt-3">
                  <p className="text-[11px] text-gray-600">
                    Student, Azim Premji University
                  </p>
                </div>
              </div>

              {/* Back face — Full logo filling the card */}
              <div
                className="absolute inset-0 flex items-center justify-center p-6 bg-white rounded-2xl overflow-hidden"
                style={{ backfaceVisibility: "hidden", transform: "rotateY(180deg)" }}
              >
                <img 
                  src="https://customer-assets.emergentagent.com/job_laughing-sinoussi-3/artifacts/9qpmve3h_image.png" 
                  alt="Azim Premji University" 
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default TestimonialsGrid;
